import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Alert
} from "@mui/material";
import * as apiRemitos from "../api"; 

function RemitoDetailPanel({ remitoId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const fetchItems = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await apiRemitos.fetchItemsRem(remitoId); 
        if (isMounted) {
          setItems(data || []);
        }
      } catch (err) {
        if (isMounted) {
          setError("Ocurrió un error al cargar los ítems del remito.");
          console.error(err);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    if (remitoId) {
      fetchItems();
    }

    return () => {
      isMounted = false;
    };
  }, [remitoId]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 2, bgcolor: "#f8fafc" }}>
        <CircularProgress size={20} />
        <Typography variant="body2" color="text.secondary">
          Cargando ítems del remito...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!items || items.length === 0) {
    return (
      <Box sx={{ p: 2, bgcolor: "#f8fafc" }}>
        <Typography variant="body2" color="text.secondary">
          El remito no contiene ítems agregados.
        </Typography>
      </Box>
    );
  }

 return (
    <Box sx={{ p: 2, bgcolor: "#f8fafc", width: "100%", boxSizing: "border-box" }}>
      <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: "primary.main" }}>
        Ítems del Remito
      </Typography>
      
      {/* width: "100%" en el Paper */}
      <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden", width: "100%" }}>
        <Table size="small" sx={{ width: "100%" }}>
          <TableHead sx={{ bgcolor: "action.hover" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Cantidad</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Unidad de Medida</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Producto</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={item.id || index} hover>
                <TableCell>{item.cantidad}</TableCell>
                <TableCell>{item.unidad_medida || item.nombre_um}</TableCell>
                <TableCell>{item.producto || item.nombre_producto}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}

export default RemitoDetailPanel;